import { Dispatch } from 'redux';

import { requestBot } from '../../lib/request';

export const REGISTRATION_CHECK_BIN_REQUEST = 'REGISTRATION_CHECK_BIN_REQUEST';
export const REGISTRATION_CHECK_BIN_RESPONSE = 'REGISTRATION_CHECK_BIN_RESPONSE';
export const REGISTRATION_CHECK_BIN_ERROR = 'REGISTRATION_CHECK_BIN_ERROR';

export const REGISTRATION_REQUEST = 'REGISTRATION_REGISTRATION_REQUEST';
export const REGISTRATION_RESPONSE = 'REGISTRATION_REGISTRATION_RESPONSE';
export const REGISTRATION_ERROR = 'REGISTRATION_REGISTRATION_ERROR';

export const REGISTRATION_SEND_CODE_REQUEST = 'REGISTRATION_SEND_CODE_REQUEST';
export const REGISTRATION_SEND_CODE_RESPONSE = 'REGISTRATION_SEND_CODE_RESPONSE';
export const REGISTRATION_SEND_CODE_ERROR = 'REGISTRATION_SEND_CODE_ERROR';

export const SET_BIN = 'REGISTRATION_SET_BIN';
export const SET_NAME = 'REGISTRATION_SET_NAME';
export const SET_SURNAME = 'REGISTRATION_SET_SURNAME';

export const RESET_REGISTRATION = 'RESET_REGISTRATION';
export const RESET_SEND_CODE_REGISTRATION = 'RESET_SEND_CODE_REGISTRATION';

export const resetRegistrationAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_REGISTRATION,
});

export const resetSendCodeRegistrationAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_SEND_CODE_REGISTRATION,
});

export const setBinAction = (bin: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_BIN,
    bin,
});

export const setNameAction = (name: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_NAME,
    name,
});

export const setSurnameAction = (surname: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_SURNAME,
    surname,
});

export const checkBinAction = (bin: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: REGISTRATION_CHECK_BIN_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/registration/checkBin`, {
        method: 'POST',
        headers: new Headers({
            'Content-type': 'application/json',
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
        body: JSON.stringify({
            bin,
        }),
    }).then(response => dispatch({
        type: REGISTRATION_CHECK_BIN_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: REGISTRATION_CHECK_BIN_ERROR,
        error,
    }));
};

export const registrationAction = (bin: string, phone: string, name: string, surname: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: REGISTRATION_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/registration`, {
        method: 'POST',
        headers: new Headers({
            'Content-type': 'application/json',
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
        body: JSON.stringify({
            bin,
            phone,
            name,
            surname,
        }),
    }).then(response => dispatch({
        type: REGISTRATION_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: REGISTRATION_ERROR,
        error,
    }));
};

export const registrationSendCodeAction = (body: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: REGISTRATION_SEND_CODE_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/authorization/sendCode`, {
        method: 'POST',
        headers: new Headers({
            'Content-type': 'application/json',
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
        body,
    }).then(response => dispatch({
        type: REGISTRATION_SEND_CODE_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: REGISTRATION_SEND_CODE_ERROR,
        error,
    }));
};



// WEBPACK FOOTER //
// ./src/actions/Registration/registration.ts